// @flow
import React, { Component } from 'react'
import ErrorText from '../controls/ErrorText'
import styled, { type StyledComponent } from 'styled-components'
import _ from 'lodash'

const currencyWidth = 15
const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: table;
`
const StyledInput: StyledComponent<Object, any, any> = styled.input`
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin: 0;
  padding-right: ${currencyWidth + 5}px;
  text-align: right;
  max-width: 100px;
`
const InputWrapper: StyledComponent<Object, any, any> = styled.div`
  position: relative;
  display: inline-block;
  align-items: center;
`
const Currency: StyledComponent<Object, any, any> = styled.div`
  position: absolute;
  right: 0;
  bottom: 10px;
  width: ${currencyWidth}px;
  text-align: left;
`

type Props = {|
  minimalTotalLimit: number,
  errors: Array<string>,
  totalLimit: string,
  onChange: Function
|}

type State = {|
  errors: Array<string>
|}

const t = {
  currency: '₽',
  minimum_value: 'минимум'
}

export default class TotalLimit extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      errors: props.errors || []
    }
  }

  render() {
    const { totalLimit } = this.props
    const { errors } = this.state
    return (
      <Wrapper>
        <InputWrapper>
          <StyledInput
            value={isNaN(totalLimit) ? '' : totalLimit}
            onChange={(e) => this.changed({ totalLimit: e.target.value })}
            id="audience_total_limit"
            type="text"
          />
          <Currency>{t.currency}</Currency>
        </InputWrapper>
        <ErrorText errors={errors} />
      </Wrapper>
    )
  }

  changed(diff: { totalLimit: string }) {
    const { onChange } = this.props
    const { totalLimit, errors } = this.validate(diff.totalLimit)

    onChange({ totalLimit, errors })
    this.setState({ errors })
  }

  validate(totalLimit: string): { totalLimit: string, errors: Array<string> } {
    const { minimalTotalLimit } = this.props
    let errors = []
    totalLimit = totalLimit.replace(/\D/, '') || ''
    if (!_.isEmpty(totalLimit) && parseInt(totalLimit) < minimalTotalLimit) {
      errors = [`${t.minimum_value} ${minimalTotalLimit} ${t.currency}`]
    }

    return { totalLimit, errors }
  }
}
